export default {"src":"/_next/static/media/logo-esab.ac819888.svg","height":57,"width":103};